import { forwardRef } from "react";
import { Icon } from "@newsela/angelou";
import ArrowLineRightSvg from "./ArrowLineRight.svg.jsx";

const ArrowLineRight = forwardRef<SVGSVGElement, any>((props, ref) => {
  return <Icon ref={ref} SvgComponent={ArrowLineRightSvg} {...props} />;
});

ArrowLineRight.displayName = "ArrowLineRight";
export default ArrowLineRight;
